import { render } from "./SpecialitySection.vue?vue&type=template&id=b7fd2678&scoped=true"
import script from "./SpecialitySection.vue?vue&type=script&lang=js"
export * from "./SpecialitySection.vue?vue&type=script&lang=js"

import "./SpecialitySection.vue?vue&type=style&index=0&id=b7fd2678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7fd2678"]])

export default __exports__